import { X_AXIS_HEIGHT } from "~/crop/crop-schedule/crop-timeline/timeline-constants"

export const TIMELINE_PREVIEW_CONTAINER_HEIGHT = 160 + 35
export const TIMELINE_PREVIEW_CONTENT_HEIGHT = TIMELINE_PREVIEW_CONTAINER_HEIGHT - X_AXIS_HEIGHT  // Container - X_AXIS_HEIGHT (70)

export const SELECT_ENTITY_TOOLTIP = 'Please select a target type first'
export const SELECT_TASK_TYPE_TOOLTIP = 'Please select an organization or crop first'

export const TARGET_TYPES = [
  { code: 'org', label: 'Organization' },
  { code: 'crop', label: 'Crop' },
]

export const ORGANIZATION_TYPE_GROUP_LABELS = {
  farm: 'Farms',
  plot: 'Plots',
  patch: 'Patches',
}
